import React, { memo } from 'react'
import { Box } from '@mui/material'

/**
 * Empty pane fill while dashboard layout is loading (no chart placeholder).
 * Uses background.default (#181818 in dark theme) to match the app body.
 */
const DashboardPaneBackground = () => (
    <Box
        sx={{
            width: '100%',
            height: '100%',
            minHeight: 0,
            bgcolor: 'background.default'
        }}
    />
)

export default memo(DashboardPaneBackground)
